import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, FormControl, InputGroup, Row } from 'react-bootstrap'
import Select from "react-select";
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { toast } from "react-toastify";
import { EmptyLocalStorage } from "../../services/auth/auth.service";
import { FadeLoader } from "react-spinners";
import { GetUserById, UpdateUser } from "../../services/users.service";
import { uploadToS3 } from "../../utils/helpers";
import { GetState } from '../../services/state.service';
import { GetCity } from '../../services/city.service';

function EditUser(props) {
    let history = useHistory();
    const [data, setData] = useState([]);
    const [pass, TogglePass] = useState(true);
    const [image, setImage] = useState()
    const [isUpload, setIsUpload] = useState(false)
    const [isUploadOverWrite, setIsUploadOverWrite] = useState(false)
    const [file, setFile] = useState(null)
    const [confPass, ToggleConfPass] = useState(true);
    const [confirmPass, setConfirmPass] = useState(true);
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [age, setAge] = useState({ format: "mm/dd/yyyy" })
    const [loader, setLoader] = useState(false);
    const { register, watch, setError, clearErrors, setValue, handleSubmit, formState: { errors } } = useForm({
        mode: "onBlur",
    });
    const regex = new RegExp("^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$")
    const maxDate = new Date().toISOString().split('T')[0]; // Get today's date in ISO format
    useEffect(async () => {
        fetchStates();
        let id = props.match.params.id;
        await getUserByid(id);
    }, [])

    const fetchStates = async () => {
        try {
            const response = await GetState();
            if (response.status) {
                const stateOptions = response.data.map(state => ({
                    value: state,
                    label: state.name
                }));
                setStates(stateOptions);
            }
        } catch (error) {
            toast.error("Failed to fetch states");
        }
    };

    const fetchCities = async (stateId) => {
        try {
            const response = await GetCity(1, stateId);
            if (response.status) {
                const cityOptions = response.data.map(city => ({
                    value: city,
                    label: city.name
                }));
                setCities(cityOptions);
            }
        } catch (error) {
            toast.error("Failed to fetch cities");
        }
    };

    const getUserByid = async (id) => {
        await GetUserById(id).then((result) => {
            if (result.status) {
                if (result.data) {
                    setData(result.data);
                    setValue("fullName", result.data?.fullName);
                    setValue("email", result.data?.email);
                    // setValue("phone", result.data?.phone);
                    setValue("address", result.data?.address);
                    setValue("dob", result.data?.additionalFields?.dob ? new Date(result.data.additionalFields.dob).toLocaleDateString('en-CA') : '');
                    // setValue("gender", result.data?.gender);
                    // setValue("bio", result.data?.bio);
                    // setValue("phone", result.data?.phone);
                    // setValue("type", result.data?.type);
                    setValue("city", result.data?.city?.name);
                    setValue("state", result.data?.state?.name);
                    if (result.data?.state) {
                        const stateOption = { value: result.data?.state, label: result.data.state.name };
                        setSelectedState(stateOption);
                        fetchCities(result.data.state.id);
                    }

                    if (result.data?.city) {
                        const cityOption = { value: result.data.city, label: result.data.city.name };
                        setSelectedCity(cityOption);
                    }

                    if (result.data?.profileImage) {
                        setImage(result.data?.profileImage)
                        setIsUpload(true)
                    }
                }
            } else {
                return toast.error(result.message);
            }
        }).catch((error) => {
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else {
                return toast.error(error.response.data.message);
            }
        })
    }


    const password = useRef({});
    password.current = watch("password", "");

    const onSubmit = async data => {
        if (isUploadOverWrite) {
            if (file.type.startsWith('image/')) {
                clearErrors('profileImage')
            } else {
                setError('profileImage', { message: 'Invalid file type' })
                return false;
            }
        }
        setLoader(true)
        if (isUploadOverWrite) {
            if (!file) {
                setError('profileImage', { message: "Media is required" })
            }

            let uploadImage = await uploadToS3(file.type, file.name, file, 'user');

            if (uploadImage) {
                if (!uploadImage) {
                    setLoader(false)
                    toast.error(uploadImage.message);
                    return false;
                }
            } else {
                setLoader(false)
                toast.error('Can\'t Upload Image');
                return false;
            }
            data.profileImage = uploadImage;
        } else {
            data.profileImage = image
        }
        let id = props.match.params.id;
        let dt = {
            fullName: data.fullName,
            address: data.address,
            additionalFields: {
                dob: data.additionalFields?.dob,
            },
            state: selectedState?.value || '-',
            city: selectedCity?.value || '-',
            // gender:data.gender,
            // bio:data.bio || null,
            // phone:data.phone || null,
            // type:data.type,
            // device_type: 'web',
            // device_token: 'user',
            profileImage: data.profileImage,
        }
        if (data.password && data.password_confirmation) {
            dt.password = data.password;
            dt.password_confirmation = data.password_confirmation;
        }
        await UpdateUser(id, dt).then(async (data) => {
            setLoader(false)
            if (data.status) {
                toast.success(data.message);
                history.push('/manage-users');
            } else {
                setLoader(false)
                toast.error(data.message);
            }
        }).catch((error) => {
            setLoader(false);
            if (error.response.status === 401) {
                EmptyLocalStorage();
                history.push('/');
            } else {
                if (error.response.data.status === false && error.response.data.message && error.response.data.data && Array.isArray(error.response.data.data)) {
                    const errorMessages = error.response.data.data.map((message) => message).join(", ");
                    toast.error(`${error.response.data.message}: ${errorMessages}`);
                } else {
                    toast.error(error.response.data.message);
                }
            }
        })


    };

    const onAgeChange = (e) => {
        const object = e.target.value;
        const date = new Date(object);
        setAge(date.toLocaleDateString())
    }

    const uploadFile = async (fileInput) => {

        let fileUrl = URL.createObjectURL(fileInput[0])
        setImage(fileUrl)
        setFile(fileInput[0])
        setIsUpload(true)
        if (fileUrl) {
            setIsUploadOverWrite(true)
        }

    }

    const validateMedia = (fileList) => {
        const file = fileList[0];
        if (file && file.size > 5 * 1024 * 1024) {
            return 'Image size should be less than 5MB';
        }
        return true; // Validation passed
    };
    return (
        <div className="EditUser">
            {/*<BreadcrumbsComponent />*/}
            <h3 className="page-heading">Edit User</h3>
            <hr />
            <Row>
                <Col xs={12} sm={12} md={10} lg={12} xl={6}>
                    <Form className="formAddUser" autoComplete="off" role="presentation" onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="image">
                                    <Form.Label>Image <Form.Text className=" text-muted" style={{ fontSize: ".675em" }}>(Max upload file size: 5 MB)</Form.Text> </Form.Label>
                                    <input
                                        {...register('profileImage', {
                                            validate: validateMedia // Use the custom validation function
                                        })}
                                        onChange={(e) => uploadFile(e.target.files)}
                                        type='file'
                                        accept={'.jepg,.jpg,.png'}
                                        class="custom-file-input"
                                        id='image'
                                    />

                                    <br />
                                    {errors.profileImage && <Form.Text
                                        className=" validationText hasError">{errors.profileImage.message}</Form.Text>}

                                </Form.Group>
                            </Col>
                        </Row>
                        {isUpload ?
                            <Row>
                                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                    <ul className={"list-inline list-variations"}>
                                        <li className={"list-inline-item d-flex justify-content-between mb-0"}>
                                            <img src={image} width="50%" height="50%" />
                                        </li>
                                    </ul>
                                </Col>
                            </Row>
                            : ""
                        }
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="fullName">
                                    <Form.Label>Full Name*</Form.Label>
                                    <Form.Control
                                        placeholder="Enter Full Name"
                                        id={"formSignUpName"}
                                        maxLength={25}
                                        minLength={3}
                                        {...register('fullName', {
                                            required: {
                                                value: "required",
                                                message: "Full Name is required"
                                            },
                                            pattern: {
                                                value: /^(?!\s).*$/,
                                                message: "Full Name should not start with a space"
                                            },
                                            minLength: {
                                                value: 2,
                                                message: "Min length is 2"
                                            },
                                            maxLength: {
                                                value: 100,
                                                message: "Max length is 100"
                                            },
                                        })} type="text"
                                    />
                                    {errors.fullName && <Form.Text
                                        className="text-muted validationText hasError">{errors.fullName.message}</Form.Text>}

                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Label>Email*</Form.Label>
                                    <Form.Control
                                        placeholder="Enter Email Address"
                                        autocomplete="off"
                                        autofill="off"
                                        maxLength={255}
                                        {...register('email', {
                                            required: {
                                                value: "required",
                                                message: "Email is required"
                                            },
                                            pattern: {
                                                value: /\S+@\S+\.\S+/,
                                                message: "Entered value does not match email format"
                                            },
                                            maxLength: {
                                                value: 100,
                                                message: "Max length is 100"
                                            },
                                        })} type="email" readOnly />
                                    {errors.email && <Form.Text
                                        className="text-muted validationText hasError">{errors.email.message}</Form.Text>}
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>

                                <Form.Group className="mb-3" controlId="state">
                                    <Form.Label>State*</Form.Label>
                                    <Select
                                        options={states}
                                        placeholder="Select State"
                                        value={selectedState}
                                        onChange={(option) => {
                                            setSelectedState(option);
                                            fetchCities(option.value.id); // Fetch cities for the selected state
                                            setSelectedCity(null);
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>

                                <Form.Group className="mb-3" controlId="city">
                                    <Form.Label>City*</Form.Label>
                                    <Select
                                        options={cities}
                                        placeholder="Select City"
                                        value={selectedCity}
                                        isDisabled={!selectedState}
                                        onChange={(option) => setSelectedCity(option)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>DOB*</Form.Label>
                                    <Form.Control
                                        id={"age"}
                                        placeholder="Enter Age"
                                        value={age.date}
                                        max={maxDate}
                                        maxLength={3}
                                        {...register('dob', {
                                            required: {
                                                value: "required",
                                                message: "DOB is required"
                                            },
                                            onChange: (e) => onAgeChange(e),
                                        })} type="date"
                                    />
                                    {errors.dob && <Form.Text
                                        className=" validationText hasError">{errors.dob.message}</Form.Text>}
                                </Form.Group>
                            </Col>
                            {/* <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="phone">
                                    <Form.Label>Phone</Form.Label>
                                    <Form.Control
                                        placeholder="Enter Phone"
                                        id={"formSignUpName"}
                                        maxLength={25}
                                        minLength={3}
                                        {...register('phone', {
                                            pattern: {
                                                value: regex,
                                                message: "Please enter valid phone number"
                                            },
                                            maxLength: {
                                                value: 25,
                                                message: "Max length is 25"
                                            },
                                        })} type="number"
                                    />
                                    {errors.phone && <Form.Text
                                        className="text-muted validationText hasError">{errors.phone.message}</Form.Text>}

                                </Form.Group>
                            </Col> */}

                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Group className="mb-3" controlId="address">
                                    <Form.Label>Address*</Form.Label>
                                    <Form.Control
                                        placeholder="Enter Address"
                                        autocomplete="off"
                                        autofill="off"
                                        {...register('address', {
                                            required: {
                                                value: "required",
                                                message: "Address is required"
                                            },
                                            minLength: {
                                                value: 2,
                                                message: "Max length is 2"
                                            },
                                            maxLength: {
                                                value: 200,
                                                message: "Max length is 200"
                                            },
                                            validate: {
                                                notOnlySpaces: value => value.trim() !== "" || "Address cannot be only spaces"
                                            }
                                        })} type="text" />
                                    {errors.address && <Form.Text
                                        className="text-muted validationText hasError">{errors.address.message}</Form.Text>}
                                </Form.Group>
                            </Col>

                            {/* <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Form.Group className="mb-3" controlId="text">
                                    <Form.Label>Bio</Form.Label>
                                    <textarea
                                        id='custom-text-area'
                                        rows={6} className={'w-100'}
                                        placeholder="Enter Bio"
                                        {...register('bio', {
                                            pattern:{
                                                value:/^(?!\s).*$/,
                                                message:"Bio should not start with a space"
                                            },
                                            minLength: {
                                                value: 10,
                                                message: "Min length is 10"
                                            },
                                            maxLength: {
                                                value: 300,
                                                message: "Max length is 300"
                                            },
                                            onChange: (e) => setValue('bio',e.target.value.trimStart()),
                                        })} type="text" />
                                    {errors.bio && <Form.Text
                                        className=" validationText hasError">{errors.bio.message}</Form.Text>}

                                </Form.Group>
                            </Col> */}
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                {loader ? <div className="spin-loader">
                                    <FadeLoader color={"#41D2D2"} height={10} />
                                </div> :
                                    <input type={"submit"} className={"btn btn-green-theme w-100 mt-3"}
                                        value={"Update User"} />}
                            </Col>


                        </Row>
                    </Form>

                </Col>
            </Row>

        </div>
    )
}

export default EditUser
